import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  TitleStrategy,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';

import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { Tab } from 'primeng/tabs';
import { viaOnePreset } from '../../viaone-preset';
import { FormatClaimPipe } from '../pipes/format-claim.pipe';
import { JoinPipe } from '../pipes/join.pipe';
import { ErrorHandlerService } from '../services/error-handler/error-handler.service';
import { dateInterceptor } from '../services/http/date-interceptor';
import { Session } from '../services/session/session.service';
import { routes } from './app.routes';
import { RouteStrategy } from './routeStrategy';
import { flipDialogPaginatorDropdown } from './core/table/dialog-paginator-dropdown-flip';
import { OmniInsightsTitleStrategy } from '../services/omni-insights-title/omni-insights-title.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withComponentInputBinding(),
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([dateInterceptor])),
    provideAppInitializer(async () => {
      await inject(Session).initialize();
    }),
    DatePipe,
    JoinPipe,
    FormatClaimPipe,
    MessageService,
    DialogService,
    CookieService,
    providePrimeNG({
      theme: {
        preset: viaOnePreset,
        options: {
          darkModeSelector: false,
        },
      },
      overlayOptions: {
        onAnimationStart: flipDialogPaginatorDropdown,
      },
    }),
    { provide: RouteReuseStrategy, useClass: RouteStrategy },
    { provide: TitleStrategy, useClass: OmniInsightsTitleStrategy },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
  ],
};

/**
 Patch to fix missing active tab in release
 https://github.com/primefaces/primeng/issues/19110
 */
(Tab.prototype as any)['componentName'] = 'tab';
